export enum BlobContainers {
  ProfileImages = 'profileimages',
  PropertyImages = 'propertyimages',
  DynamicPropertyFiles = 'dynamicpropertyfiles',
  Flat2DImages = 'flatimages',
  Villa2DImages = 'villaimages',
  Commercial2DImages = 'commercialimages',
  Plot2DImages = 'plotimages',
  DocumentTemplates = 'documenttemplates',
  CancelUnitRequestProof = 'cancelunitrequestproofs',
  CustomerDocuments = 'customerdocuments',
  LeadBrochures = 'propertybrouchers',
  PaymentReferenceFile = 'paymentreferencefile',
  CommunicationTemplates = 'communicationtemplates',
  ProjectDocuments = 'projectdocuments',
  Flat3DImages = 'flat3dimages',
  Commercial3DImages = 'commercial3dimages',
  Villa3DImages = 'villa3dimages',
  AllotmentLetters = 'allotmentletters',
  UnitCustomizationRequestProof = 'unitcustomizationrequest',
  AgreementForSale = 'agreementforsale',
  SaleDeed = 'saledeed',
  TripartiteAgreement = 'triparteagreement',
  TDSReceiptProof = 'tdsreceiptproofs',
  SatisfactionOfCompletedWorkLetter = 'satisfactionofcompletedworkletter',
  HandoverLetter = 'handoverletter',
  CancellationLetter = 'cancellationletter',
  SiteDocuments = 'sitedocuments',
  PropertyModels = 'propertysitemodels'
}
